import { render, staticRenderFns } from "./TvProgram.vue?vue&type=template&id=31fe4ff0"
import script from "./TvProgram.vue?vue&type=script&lang=js"
export * from "./TvProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports